module.exports = __webpack_public_path__ + "static/media/AudioSwitchBtn_1K_stop_white.4e26d4a5.svg";